import {
  SET_PARAMETERS_INFERENTIAL_STATISTICS,
  RESET_PARAMETERS_INFERENTIAL_STATISTICS,
  RESET_INFERENTIAL_STATISTICS,
  SET_HAS_NUMERICAL_VARIABLES_EMPTY_CELL,
  SET_HAS_CATEGORICAL_VARIABLES_EMPTY_CELL
} from './types';
import { RESET_DATASET } from 'store/dataset/types';

const initialState = {
  isCalculated: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PARAMETERS_INFERENTIAL_STATISTICS:
      return { ...state, ...action.values };
    case RESET_PARAMETERS_INFERENTIAL_STATISTICS:
      return { ...initialState };
    case RESET_DATASET:
    case RESET_INFERENTIAL_STATISTICS:
      return { ...initialState };
    case SET_HAS_NUMERICAL_VARIABLES_EMPTY_CELL:
      return { ...state, hasNumericalVariablesEmptyCell: action.hasNumericalVariablesEmptyCell };
    case SET_HAS_CATEGORICAL_VARIABLES_EMPTY_CELL:
      return { ...state, hasCategoricalVariablesEmptyCell: action.hasCategoricalVariablesEmptyCell };
    default:
      return state;
  }
};
